import { Instagram, MessageCircle } from "lucide-react";

export default function FloatingSocials() {
  return (
    <div className="fixed right-4 bottom-4 md:right-6 md:bottom-6 z-30 flex flex-col gap-3" data-testid="floating-socials">
      <a href="https://wa.me/919729927206" target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp"
        className="w-12 h-12 rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg hover:scale-105"
        data-testid="whatsapp-float"
        style={{ transitionProperty: "transform", transitionDuration: "200ms" }}>
        <MessageCircle className="h-5 w-5" />
      </a>
      <a href="https://www.instagram.com/the_fabrics.in" target="_blank" rel="noreferrer" aria-label="Follow on Instagram"
        className="w-12 h-12 rounded-full text-white grid place-items-center shadow-lg hover:scale-105"
        style={{ background: "linear-gradient(135deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)", transitionProperty: "transform", transitionDuration: "200ms" }}
        data-testid="instagram-float">
        <Instagram className="h-5 w-5" />
      </a>
    </div>
  );
}
